<template>
  <div>
    <v-data-table :headers="headers" :items="templates" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Templates</v-toolbar-title>
          <div class="flex-grow-1">
            <v-btn class="secondary float-right ml-2" @click="helpDialog = true"
              ><v-icon left dark>mdi-help-circle</v-icon>Fields</v-btn
            >
            <v-btn
              class="primary float-right"
              :loading="dialog"
              @click="addTemplate()"
              >Add Template</v-btn
            >
          </div>
        </v-toolbar>
      </template>

      <template v-slot:item.emailOrSMS="{ value, item }">
        <span v-if="item.emailOrSMS">Email</span>
        <span v-else>SMS</span>
      </template>

      <template v-slot:item.action="{ value, item }">
        <v-btn color="primary" class="text-uppercase" @click="test(item)"
          >Edit</v-btn
        >
        &nbsp;
        <v-btn
          color="primary"
          class="text-uppercase"
          @click="deleteRecord(item)"
          >Delete</v-btn
        >
      </template>
    </v-data-table>
    <template-dialog
      :dialog="dialog"
      :add="add"
      @cancel="dialog = !dialog"
      :template="template"
    ></template-dialog>
    <v-dialog v-model="helpDialog" width="1000" persistent>
      <template-fields @cancel="helpDialog = false"></template-fields>
      <!-- <letter-merge-fields @cancel="closeFieldDialog"></letter-merge-fields> -->
    </v-dialog>
  </div>
</template>

<script>
import TemplateDialog from "@/components/dialogs/TemplateDialog";
import TemplateFields from "@/components/dialogs/TemplateFields";

import { mapActions } from "vuex";
export default {
  name: "Templates",
  components: {
    TemplateDialog,
    TemplateFields
  },
  data: () => ({
    dialog: false,
    add: false,
    template: {},
    headers: [
      { text: "ID", value: "id", sortable: false },
      { text: "Stage", value: "stage", sortable: false },
      { text: "Type", value: "emailOrSMS", sortable: false },
      { text: "Name", value: "name", sortable: false },
      { text: "", value: "action", sortable: false }
    ],
    templates: [],
    helpDialog: false
  }),
  watch: {
    dialog: function(newVal) {
      if (!newVal) {
        this.loadTemplates();
      }
    }
  },
  methods: {
    ...mapActions("template", ["getTemplates", "deleteTemplate"]),
    loadTemplates() {
      this.getTemplates().then(data => {
        this.templates = data;
      });
    },
    test(item) {
      this.template = item;
      this.template.mode = this.template.emailOrSMS.toString();
      this.add = false;
      this.dialog = !this.dialog;
    },
    getDeleteConfirm() {
      return window.confirm("Do you really want to delete this template?");
    },
    deleteRecord(item) {
      if (this.getDeleteConfirm()) {
        this.deleteTemplate(item).then(data => {
          if (data.length != 0) {
            this.loadTemplates();
          }
        });
      }
    },
    addTemplate() {
      this.template = {
        templateSubject: null,
        template: null,
        mode: null,
        name: null,
        stage: "Courtesy"
      };
      this.add = true;
      this.dialog = true;
    }
  },
  mounted() {
    setTimeout(() => {
      this.loadTemplates();
    }, 100);
  }
};
</script>
